import React, { FC, useEffect, useState } from 'react'

import { ClockIcon } from '~/assets/icons'
import { dateDiffInSeconds, generateTimeLeft, MILLISECONDS_IN_A_SECOND } from '~/components/deal/utils/date'

import styles from './styles.module.css'

interface CountdownBadgeProps {
  endDate: Date
  criticalJs: boolean
}

const CountdownBadge: FC<CountdownBadgeProps> = ({ endDate, criticalJs }) => {
  const [countdown, setCountdown] = useState(dateDiffInSeconds(new Date(), endDate) as number)

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((countdown) => countdown - 1)
      if (countdown <= 0) {
        clearInterval(timer)
      }
    }, MILLISECONDS_IN_A_SECOND)

    return () => clearInterval(timer)
  }, [countdown])

  const timeLeft = generateTimeLeft(countdown)
  const label = criticalJs && !['Ends today', 'Ends soon'].includes(timeLeft) ? 'Ends soon' : timeLeft

  return (
    <div className={styles.countdown}>
      <ClockIcon />
      <span className={styles.countLabel}>{label}</span>
    </div>
  )
}

export default CountdownBadge
